import { render } from "./CustomerPaymentConfirmReset.vue?vue&type=template&id=04350054&scoped=true"
import script from "./CustomerPaymentConfirmReset.vue?vue&type=script&lang=js"
export * from "./CustomerPaymentConfirmReset.vue?vue&type=script&lang=js"

import "./CustomerPaymentConfirmReset.vue?vue&type=style&index=0&id=04350054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04350054"]])

export default __exports__